import React, { useState } from "react";
import { X, MailWarning } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// Phase 14 — SOFT email verification nudge (F&F policy: account usable
// immediately; this banner just nudges password-registered users to confirm
// their inbox). Google sign-ins arrive pre-verified; demo accounts are skipped.
export const VerifyEmailBanner = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("veb_dismissed") === "1");
  const [sent, setSent] = useState(false);

  const show = user && user.has_password && !user.email_verified &&
    !(user.email || "").endsWith("@demo.civic") && !dismissed;
  if (!show) return null;

  const resend = async () => {
    try {
      await api.resendVerifyEmail();
      setSent(true);
      toast.success("Verification email sent — check your inbox");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not send the email — try again shortly");
    }
  };

  const dismiss = () => {
    sessionStorage.setItem("veb_dismissed", "1");
    setDismissed(true);
  };

  return (
    <div data-testid="verify-email-banner" className="bg-amber-50 border-b border-amber-200">
      <div className="max-w-6xl mx-auto px-6 py-2.5 flex items-center gap-3 text-sm">
        <MailWarning className="w-4 h-4 text-amber-600 shrink-0" />
        <span className="text-amber-800 min-w-0">
          Please verify your email — we sent a link to <strong>{user.email}</strong>.
        </span>
        {!sent && (
          <button
            data-testid="verify-email-resend-btn"
            onClick={resend}
            className="text-amber-900 font-semibold underline underline-offset-2 shrink-0"
          >
            Resend link
          </button>
        )}
        <button
          data-testid="verify-email-dismiss-btn"
          onClick={dismiss}
          aria-label="Dismiss"
          className="ml-auto text-amber-500 hover:text-amber-700 shrink-0"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
